import { ReactNode } from 'react';
import IntersectionObserver from '@researchgate/react-intersection-observer';

import useWindowSize from '@/hooks/useWindowSize';
import { StyledNarrativeIntersectionObserver } from './styled';

type Props = {
  children: ReactNode;
  id: string;
  onIntersection: (event: IntersectionObserverEntry) => void;
};

export const NarrativeIntersectionObserver = ({
  children,
  id,
  onIntersection,
}: Props) => {
  const { height } = useWindowSize();
  const isServerSide = RUNTIME_ENV === 'server';

  if (isServerSide) {
    return <>{children}</>;
  }

  // NOTE: This is a workaround to retrieve the safeAreaInsetTop
  // NOTE: The rootMargin property enforces px or % values passed as a string
  // https://github.com/w3c/csswg-drafts/issues/2732
  // https://benfrain.com/how-to-get-the-value-of-phone-notches-environment-variables-env-in-javascript-from-css
  const element = window.document.querySelector(`#${id}`);
  const safeAreaInsetTop = element
    ? parseInt(
        getComputedStyle(element).getPropertyValue('--safeAreaInsetTop'),
        10
      )
    : 0;

  const topMargin = 121 + safeAreaInsetTop;
  const bottomMargin = height ? height - topMargin : 0;
  const rootMargin = `-${topMargin}px 0px -${bottomMargin}px 0px`;

  return (
    <IntersectionObserver
      onChange={onIntersection}
      threshold={0}
      rootMargin={rootMargin}
    >
      <StyledNarrativeIntersectionObserver id={id}>
        {children}
      </StyledNarrativeIntersectionObserver>
    </IntersectionObserver>
  );
};
